function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "kvp-reliability_svg__a",
  x1: "0%",
  x2: "100%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E6E6E6"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M4 89h88V56H4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 68.5l65.993-.41M15 77.5l65.993-.41",
  strokeWidth: 4
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M63 43.5c0-8.291 7.443-16.998 17.858-16.998h4.752c3.921-15.097 18.821-24.69 34.282-22.072 15.46 2.618 26.326 16.574 24.998 32.11-1.327 15.537-14.404 27.472-30.087 27.46h-8.857"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#kvp-reliability_svg__a)",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M76.724 50.64l13.422 13.422 13.125-13.422M89.998 61.422l.184-31.832",
  transform: "scale(1 -1) rotate(-45 -25.675 -6.828)"
}));

function SvgKvpReliability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149 93"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDkgOTMiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjAlIiB4Mj0iMTAwJSIgeTE9IjU1LjMzOSUiIHkyPSI1NS4zMzklIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjMDA5MDdGIi8+PHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjNDhENTlGIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyBzdHJva2U9IiNFNkU2RTYiPjxwYXRoIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iOCIgZD0iTTQgODloODhWNTZINHoiLz48ZyBzdHJva2Utd2lkdGg9IjQiPjxwYXRoIGQ9Ik0xNSA2OC41bDY1Ljk5My0uNDFNMTUgNzcuNWw2NS45OTMtLjQxIi8+PC9nPjwvZz48cGF0aCBzdHJva2U9IiNFNkU2RTYiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iOCIgZD0iTTYzIDQzLjVjMC04LjI5MSA3LjQ0My0xNi45OTggMTcuODU4LTE2Ljk5OGg0Ljc1MmMzLjkyMS0xNS4wOTcgMTguODIxLTI0LjY5IDM0LjI4Mi0yMi4wNzIgMTUuNDYgMi42MTggMjYuMzI2IDE2LjU3NCAyNC45OTggMzIuMTEtMS4zMjcgMTUuNTM3LTE0LjQwNCAyNy40NzItMzAuMDg3IDI3LjQ2aC04Ljg1NyIvPjxwYXRoIHN0cm9rZT0idXJsKCNhKSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI4IiBkPSJNNzYuNzI0IDUwLjY0bDEzLjQyMiAxMy40MjIgMTMuMTI1LTEzLjQyMk04OS45OTggNjEuNDIybC4xODQtMzEuODMyIiB0cmFuc2Zvcm09InNjYWxlKDEgLTEpIHJvdGF0ZSgtNDUgLTI1LjY3NSAtNi44MjgpIi8+PC9nPjwvc3ZnPgo=";
export { SvgKvpReliability as ReactComponent };